var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPath104(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 158.68,
    height: 158.68,
    viewBox: "0 0 158.68 158.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M1784.972,555.592a79.34,79.34,0,1,0,79.346,79.346,79.339,79.339,0,0,0-79.346-79.346m35.5,101.128a9.7,9.7,0,0,1-13.709,13.721l-21.794-21.794-21.782,21.794a9.7,9.7,0,0,1-13.709-13.721l21.782-21.782-21.782-21.782a9.7,9.7,0,0,1,13.709-13.721l21.782,21.782,21.794-21.782a9.7,9.7,0,0,1,13.709,13.721l-21.782,21.782Z",
    transform: "translate(-1705.638 -555.592)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath104);
export default __webpack_public_path__ + "static/media/Path 104.06a426995b3611253fa1599874979ea7.svg";
export { ForwardRef as ReactComponent };